import { SvgIconComponent } from '@cp/ds/src/components/svgIcon';
import { TelegramIconRound } from '@cp/ds/src/icons/social/round/telegramRound';
import { ViberIconRound } from '@cp/ds/src/icons/social/round/viberRound';
import { VkIconRound } from '@cp/ds/src/icons/social/round/vkRound';
import { InternalChatIconRound } from '@cp/ds/src/icons/social/round/internalChatRound';
import { MailIconRound } from '@cp/ds/src/icons/social/round/mailRound';
import { PhoneIconRound } from '@cp/ds/src/icons/social/round/phoneRound';
import { WhatsAppIconRound } from '@cp/ds/src/icons/social/round/whatsAppRound';
import { pathGenerator } from '@cp/entities/clientWebRoutes';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { ClientContactType } from '../../../../../../../common/model/client/clientContactType';
import { ClientContactViewModel } from '../../../../../../../common/model/client';
import { ClientWebPage } from './../../../../../../../common/model/meta/clientWebPage';

export const contactsLayoutDict: Partial<
  Record<
    ClientContactType,
    {
      icon: SvgIconComponent;
      label: string | ((contact: ClientContactViewModel) => string);
      linkResolver: (
        contact: ClientContactViewModel,
        payload: {
          generateAppPath: typeof pathGenerator;
          catalogItem: CatalogItemViewModel;
        },
      ) => string;
    }
  >
> = {
  [ClientContactType.WhatsApp]: {
    icon: WhatsAppIconRound,
    label: 'WhatsApp',
    linkResolver: (contact) => `https://api.whatsapp.com/send?phone=${contact.value.replace(/\D/g, '')}`,
  },
  [ClientContactType.Telegram]: {
    icon: TelegramIconRound,
    label: 'Telegram',
    linkResolver: (contact) => `https://telegram.me/${contact.value}`,
  },
  [ClientContactType.Viber]: {
    icon: ViberIconRound,
    label: 'Viber',
    linkResolver: (contact) => `viber://chat?number=%2B${contact.value.replace(/\D/g, '')}`,
  },
  [ClientContactType.VK]: {
    icon: VkIconRound,
    label: 'Вконтакте',
    linkResolver: (contact) => `https://vk.com/${contact.value}`,
  },
  [ClientContactType.Email]: {
    icon: MailIconRound,
    label: 'Email',
    linkResolver: (contact) => `mailto:${contact.value}`,
  },
  [ClientContactType.InnerChat]: {
    icon: InternalChatIconRound,
    label: 'Онлайн чат',
    linkResolver: (contact, { generateAppPath, catalogItem }) =>
      generateAppPath({
        page: ClientWebPage.ProfileMessages,
        queryParams: { catalogItemId: catalogItem.id },
      }),
  },
  [ClientContactType.Phone]: {
    icon: PhoneIconRound,
    label: (contact) => `Позвонить ${contact.value}`,
    linkResolver: (contact) => `tel:${contact.value}`,
  },
};
